import { CalendarOptionsFilters } from '@modules/front-office/interface/fo-grids-api.interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: CalendarOptionsFilters = {
  rooms: [],
  rates: [],
  locationBuilding: 0,
  locationFloor: 0,
  gridTypes: [],
  bookingStatuses: [],
};

export const FOCalendarFiltersSlice = createSlice({
  name: 'foCalendarFilters',
  initialState,
  reducers: {
    setFOCalendarFilters: (
      _state,
      action: PayloadAction<CalendarOptionsFilters>,
    ) => {
      return action.payload;
    },
    removeFOCalendarFilters: () => {
      return initialState;
    },
  },
});

export default FOCalendarFiltersSlice.reducer;

export const { setFOCalendarFilters, removeFOCalendarFilters } =
  FOCalendarFiltersSlice.actions;
